import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useMemo, useState } from "react";
import dynamic from "next/dynamic";
import Button from "@/app/components/UI/Button";
import cn from "@/app/utils/cn";
import { SelectCryptoInterface } from "@/app/components/Common/SelectCrypto/selectCrypto.interface";
import { CoinInterface } from "@/app/interfaces/coin.interface";
import { useTranslations } from "next-intl";
import useSelectedCoinStore from "@/app/stores/useSelectedCoinStore";
import CoinSVG from "../../../../../public/Icons/CoinIcons/Coin";
import { useCoinsContext } from "@/app/context/MarketContext";
import { ColorArrowDownIcon } from "@/app/components/UI/Icons";
import { useCoinNameFromSymbol } from "@/app/utils/getCoinNameFromSymbol";
const loadSelectCryptoModal = () => import("@/app/components/Common/ISelectCrypto/SelectCryptoModal");
const SelectCryptoModal = dynamic(loadSelectCryptoModal, {
  ssr: false
});
export default function ISelectCrypto(t0) {
  const $ = _c(54);
  const {
    setIsModalOpen,
    isModalOpen,
    setIsDropDownOpen,
    isDropDownOpen,
    setMarket,
    customClass: t1,
    openType: t2,
    hasMarketData: t3,
    selectedCoin: externalSelectedCoin,
    setSelectedCoin: externalSetSelectedCoin,
    title: t4,
    walletData,
    isLogin,
    label,
    autoFocus,
    allowedSymbols,
    coinsOverride,
    buttonVariant: t5,
    buttonClass,
    renderTrigger
  } = t0;
  t1 === undefined ? "" : t1;
  t2 === undefined ? "modal" : t2;
  const hasMarketData = t3 === undefined ? false : t3;
  t4 === undefined ? "" : t4;
  const buttonVariant = t5 === undefined ? "secondaryOutline" : t5;
  const t = useTranslations();
  const {
    coins,
    prices,
    markets
  } = useCoinsContext();
  const getCoinFromSymbol = useCoinNameFromSymbol();
  let t6;
  if ($[0] !== allowedSymbols) {
    t6 = allowedSymbols ? new Set(allowedSymbols.map(_temp)) : null;
    $[0] = allowedSymbols;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const allowedSymbolSet = t6;
  let t7;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = [];
    $[2] = t7;
  } else {
    t7 = $[2];
  }
  const [coinsList, setCoinsList] = useState(t7);
  const {
    selectedCoin: zustandCoin,
    setSelectedCoin: setZustandCoin
  } = useSelectedCoinStore();
  const fixedSelectedSymbol = allowedSymbols?.length === 1 ? allowedSymbols[0] : undefined;
  const fixedSelectedCoin = fixedSelectedSymbol ? coinsList.find(coin => coin.symbol?.toUpperCase() === fixedSelectedSymbol.toUpperCase()) : undefined;
  const selectedCoin = externalSelectedCoin || fixedSelectedCoin || (fixedSelectedSymbol ? undefined : zustandCoin);
  const displaySymbol = selectedCoin?.symbol || fixedSelectedSymbol;
  const setSelectedCoin = externalSetSelectedCoin || setZustandCoin;
  let t8;
  if ($[3] !== allowedSymbolSet) {
    t8 = t9 => {
      const items = t9 === undefined ? [] : t9;
      if (!allowedSymbolSet) {
        return items;
      }
      return items.filter(coin_0 => allowedSymbolSet.has(coin_0.symbol?.toUpperCase()));
    };
    $[3] = allowedSymbolSet;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  const filterAllowedSymbols = t8;
  let t9;
  if ($[5] !== coins || $[6] !== filterAllowedSymbols || $[7] !== markets) {
    t9 = () => {
      const combinedCoins = [...(Array.isArray(markets) ? markets : []), ...(Array.isArray(coins) ? coins : [])];
      const uniqueCoins = Array.from(new Map(combinedCoins.map(_temp2)).values());
      return filterAllowedSymbols(uniqueCoins);
    };
    $[5] = coins;
    $[6] = filterAllowedSymbols;
    $[7] = markets;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  const getAllowedCoins = t9;
  let t10;
  if ($[9] !== buttonVariant) {
    t10 = buttonVariant === "secondarySimple" ? {
      variant: "soft" as const,
      color: "neutral" as const
    } : {
      variant: "outline" as const,
      color: "primary" as const
    };
    $[9] = buttonVariant;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  const selectorButtonTone = t10;
  let t11;
  if ($[11] !== allowedSymbolSet || $[12] !== coins || $[13] !== coinsOverride || $[14] !== getAllowedCoins || $[15] !== hasMarketData || $[16] !== markets) {
    t11 = () => {
      if (coinsOverride) {
        setCoinsList(coinsOverride);
        return;
      }
      if (allowedSymbolSet) {
        setCoinsList(getAllowedCoins());
        return;
      }
      if (hasMarketData) {
        if (markets) {
          const marketsCoin = Array.isArray(markets) ? markets.filter(_temp3) : [];
          setCoinsList(marketsCoin);
        }
      } else {
        if (coins) {
          const filteredCoins = coins.filter(_temp4);
          setCoinsList(filteredCoins);
        }
      }
    };
    $[11] = allowedSymbolSet;
    $[12] = coins;
    $[13] = coinsOverride;
    $[14] = getAllowedCoins;
    $[15] = hasMarketData;
    $[16] = markets;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== allowedSymbolSet || $[19] !== coins || $[20] !== coinsOverride || $[21] !== hasMarketData || $[22] !== markets) {
    t12 = [coinsOverride, hasMarketData, markets, coins, allowedSymbolSet];
    $[18] = allowedSymbolSet;
    $[19] = coins;
    $[20] = coinsOverride;
    $[21] = hasMarketData;
    $[22] = markets;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  useEffect(t11, t12);
  let t13;
  if ($[24] !== setIsDropDownOpen || $[25] !== setIsModalOpen || $[26] !== setMarket || $[27] !== setSelectedCoin) {
    t13 = coin_4 => {
      setSelectedCoin(coin_4);
      setIsModalOpen(false);
      setIsDropDownOpen(false);
      if (setMarket) {
        setMarket(`${coin_4.symbol}-IRT`);
      }
    };
    $[24] = setIsDropDownOpen;
    $[25] = setIsModalOpen;
    $[26] = setMarket;
    $[27] = setSelectedCoin;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  const selectCoin = t13;
  let t14;
  if ($[29] !== allowedSymbolSet || $[30] !== coins || $[31] !== coinsOverride || $[32] !== getAllowedCoins || $[33] !== hasMarketData || $[34] !== isDropDownOpen || $[35] !== isModalOpen || $[36] !== markets || $[37] !== setIsDropDownOpen || $[38] !== setIsModalOpen) {
    t14 = async function getCoins() {
      loadSelectCryptoModal();
      if (coinsOverride) {
        setCoinsList(coinsOverride);
        setIsModalOpen && setIsModalOpen(!isModalOpen);
        setIsDropDownOpen && setIsDropDownOpen(!isDropDownOpen);
        return;
      }
      if (allowedSymbolSet) {
        setCoinsList(getAllowedCoins());
        setIsModalOpen && setIsModalOpen(!isModalOpen);
        setIsDropDownOpen && setIsDropDownOpen(!isDropDownOpen);
        return;
      }
      if (hasMarketData) {
        const irtMarkets = Array.isArray(markets) ? markets.filter(_temp5) : [];
        setCoinsList(irtMarkets);
      } else {
        setCoinsList(coins);
      }
      setIsModalOpen && setIsModalOpen(!isModalOpen);
      setIsDropDownOpen && setIsDropDownOpen(!isDropDownOpen);
    };
    $[29] = allowedSymbolSet;
    $[30] = coins;
    $[31] = coinsOverride;
    $[32] = getAllowedCoins;
    $[33] = hasMarketData;
    $[34] = isDropDownOpen;
    $[35] = isModalOpen;
    $[36] = markets;
    $[37] = setIsDropDownOpen;
    $[38] = setIsModalOpen;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  const getCoins = t14;
  const t15 = renderTrigger ? renderTrigger({
    onClick: getCoins,
    displaySymbol
  }) : <div className="grow"><div className="relative"><label className={cn("text-sm text-charcoal-600")}>{label}</label><div className="mt-3"><Button {...selectorButtonTone} size="md" fullWidth={true} contentClassName={cn("w-full justify-between", displaySymbol ? "md:text-lg font-semibold text-charcoal-900" : "font-medium text-charcoal-600")} suffixIcon={ColorArrowDownIcon} onClick={getCoins} className={buttonClass}><span className="flex items-center gap-2">{displaySymbol && <CoinSVG id={displaySymbol} className="h-6 w-6 md:h-8 md:w-8" />}<span className="text-sm">{displaySymbol ? getCoinFromSymbol(displaySymbol) : t("comparison.HEADER.SELECT_CRYPTO")}</span></span></Button></div></div></div>;
  let t16;
  if ($[40] !== allowedSymbols || $[41] !== autoFocus || $[42] !== coinsList || $[43] !== hasMarketData || $[44] !== isDropDownOpen || $[45] !== isLogin || $[46] !== prices || $[47] !== selectCoin || $[48] !== setIsDropDownOpen || $[49] !== walletData) {
    t16 = isDropDownOpen && <SelectCryptoModal setIsModalOpen={setIsDropDownOpen} isModalOpen={isDropDownOpen} coinsList={coinsList || []} selectCoin={selectCoin} hasMarketData={hasMarketData} walletData={walletData} prices={prices} isLogin={isLogin} autoFocus={autoFocus} allowedSymbols={allowedSymbols} />;
    $[40] = allowedSymbols;
    $[41] = autoFocus;
    $[42] = coinsList;
    $[43] = hasMarketData;
    $[44] = isDropDownOpen;
    $[45] = isLogin;
    $[46] = prices;
    $[47] = selectCoin;
    $[48] = setIsDropDownOpen;
    $[49] = walletData;
    $[50] = t16;
  } else {
    t16 = $[50];
  }
  let t17;
  if ($[51] !== t15 || $[52] !== t16) {
    t17 = <>{t15}{t16}</>;
    $[51] = t15;
    $[52] = t16;
    $[53] = t17;
  } else {
    t17 = $[53];
  }
  return t17;
}
function _temp5(coin_5) {
  return coin_5.symbol !== "IRT" && (coin_5.name?.includes("-IRT") || coin_5.name?.includes("IRT-"));
}
function _temp4(coin_3) {
  return coin_3.symbol != "IRT";
}
function _temp3(coin_2) {
  return coin_2.symbol != "IRT";
}
function _temp2(coin_1) {
  return [coin_1.symbol?.toUpperCase(), coin_1];
}
function _temp(symbol) {
  return symbol.toUpperCase();
}